document.addEventListener('DOMContentLoaded', function () {
  window.applyProductDiscount = function() {
    if (activeDiscounts.length > 0 && activeDiscounts[0].percent) {
      console.log("[Discount Apply] Active code:", activeDiscounts[0].name, "| Discount:", activeDiscounts[0].percent + "%");

      function getDiscountedPrice(priceText) {
        const decimalSeparator = priceText.includes(',') ? ',' : '.';
        const currencySymbolMatch = priceText.match(/[^\d\s.,]/);
        const currencySymbol = currencySymbolMatch ? currencySymbolMatch[0] : '';
        const numericString = priceText.replace(/[^0-9,\.]/g, '').replace(',', '.');
        const originalPrice = parseFloat(numericString);

        if (isNaN(originalPrice)) return null;

        const newPrice = (originalPrice * ((100 - activeDiscounts[0].percent) / 100)).toFixed(2);
        return currencySymbol + newPrice.replace('.', decimalSeparator);
      }

      function getNumericPrice(priceText) {
        return parseFloat(priceText.replace(/[^0-9,\.]/g, '').replace(',', '.'));
      }

      function formatPriceLike(priceText, price) {
        const decimalSeparator = priceText.includes(',') ? ',' : '.';
        const formattedPrice = Number(price).toFixed(2).replace('.', decimalSeparator);
        const priceMatch = priceText.match(/[^\d\s.,]*\d[\d.,]*\s*[A-Za-z]{0,3}/);
        const sourcePriceText = priceMatch ? priceMatch[0].trim() : priceText.trim();
        const prefixMatch = sourcePriceText.match(/^[^\d\s.,]+/);
        const suffixMatch = sourcePriceText.match(/[A-Za-z]{3,}$/);
        const prefixCurrency = prefixMatch ? prefixMatch[0] : '';
        const suffixCurrency = suffixMatch ? suffixMatch[0] : '';
        let newPriceText = formattedPrice;

        if (prefixCurrency && suffixCurrency) {
          newPriceText = prefixCurrency + formattedPrice + ' ' + suffixCurrency;
        } else if (prefixCurrency) {
          newPriceText = prefixCurrency + formattedPrice;
        } else if (suffixCurrency) {
          newPriceText = formattedPrice + ' ' + suffixCurrency;
        }

        if (priceMatch) {
          return priceText.replace(priceMatch[0], newPriceText);
        }

        return newPriceText;
      }

      let percentageOff = 0;
      document.querySelectorAll('.cart-item, #container_upsell .product-option').forEach((item) => {
        const priceTargets = item.querySelectorAll('.product-option strong[data-product-id], .product-option > span[data-product-id], .cart-item__totals .cart-item__discounted-prices dd.price.price--end[data-product-id], .cart-item__totals .cart-item__price-wrapper > span.price.price--end[data-product-id], .cart-item__totals .price.price--end > span[data-product-id]');

        priceTargets.forEach((priceEl) => {
          if (priceEl.closest('.unit-price')) return;

          let priceWrapper = priceEl.closest('.product-option, .cart-item__price-wrapper');
          let mobileComparePriceEl = priceEl.closest('.cart-item__totals')?.querySelector('.cart-item__price-wrapper.price-item--regular [data-product-id]');
          let originalPriceEl = mobileComparePriceEl || priceWrapper?.querySelector('s[data-product-id], .price-item--regular[data-product-id], .cart-item__old-price[data-product-id]');
          let originalText = originalPriceEl ? originalPriceEl.textContent.trim() : priceEl.textContent.trim();
          let newFormatted = getDiscountedPrice(originalText);

          if (newFormatted) {
            priceEl.textContent = newFormatted;
          }

          let badgeEl = priceEl.parentElement.parentElement.querySelector('.price__badge-sale');

          if (badgeEl && !badgeEl.classList.contains('price__badge-sale--free-line')) {
            let currentPrice = getNumericPrice(newFormatted.trim());
            let originalPrice = getNumericPrice(originalPriceEl.textContent.trim());

            if (originalPrice && currentPrice && originalPrice > currentPrice) {
              badgeEl.textContent = Math.round(((originalPrice - currentPrice) / originalPrice) * 100) + '% Off';
              percentageOff = Math.round(((originalPrice - currentPrice) / originalPrice) * 100);
            }
          }
        });
      });

      let subtotalEl = document.querySelector('.cart__footer .line_subtotal span');
      let subtotal = getNumericPrice(subtotalEl.textContent.trim());
      let discountedSubtotal = (subtotal * ((100 - percentageOff) / 100)).toFixed(2);
      let totalDiscount = (subtotal * percentageOff / 100).toFixed(2);

      // Cart Items Total for Mobile Header
      let totalPriceHeader = document.querySelector('.totals_header');
      if (totalPriceHeader) {
        totalPriceHeader.textContent = formatPriceLike(totalPriceHeader.textContent,discountedSubtotal);
      }
      
      // Total Discount for Badges
      let badgeHeaderMobile = document.querySelector('cart-items :not(.ab_test_price_wrapper) .price__badge-header');
      if (badgeHeaderMobile) {
        badgeHeaderMobile.textContent = formatPriceLike(badgeHeaderMobile.textContent,totalDiscount);
      }

      let badgeFooterDesktop = document.querySelector('.cart__footer :not(.ab_test_price_wrapper) .totals-desktop .price__badge-footer');
      if (badgeFooterDesktop) {
        badgeFooterDesktop.textContent = formatPriceLike(badgeFooterDesktop.textContent,totalDiscount);
      }

      // Total Discount for Mobile Footer
      let discountFooterMobile = document.querySelector('.cart__footer :not(.ab_test_price_wrapper) .totals-mobile .savings-line');
      if (discountFooterMobile) {
        discountFooterMobile.textContent = formatPriceLike(discountFooterMobile.textContent,totalDiscount);
      }

      // Total Price for Desktop and Mobile => Subtotal - total Discount + Shipping (if shipping is applied)
      let shippingEl = document.querySelector('.cart__footer .totals-mobile .shipping_price');
      let shipping = shippingEl ? shippingEl.textContent.trim().toLowerCase() : '';
      let shippingAmount = shipping && shipping !== 'free' ? getNumericPrice(shipping) : 0;
      let total = subtotal - totalDiscount + shippingAmount;

      let totalPriceDesktop = document.querySelector('.cart__footer .totals-desktop .totals__subtotal-value');
      if (totalPriceDesktop) {
        totalPriceDesktop.textContent = formatPriceLike(totalPriceDesktop.textContent,total);
      }

      let totalPriceMobile = document.querySelector('.cart__footer .totals-mobile .line_total span:last-child');
      if (totalPriceMobile) {
        totalPriceMobile.textContent = formatPriceLike(totalPriceMobile.textContent,total);
      }
    } else {
      console.log("[Discount Apply] No Price Element or valid product discount code found.");
    }
  }

  // Check and set shipping discount, expose globally
  window.applyShippingDiscount = function() {
    // Helper to get cookie value by name
    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }

    const activeCode = (getCookie('discount_code_shipping') || '').toLowerCase();
    let activeDiscountShipping = discounts_shipping.some(d => activeCode === d.name);

    if (activeDiscountShipping) {
    console.log("[Discount Apply] Active shipping discount code:", activeCode);

    let shippingLine = document.querySelector('.price-summary .shipping_price');
    let progressBar = document.querySelector('.cart_goal .cg-wrapper');
    let totalPriceHeader = document.querySelector('#cart-header-mobile .totals_header');
    let totalPrice = document.querySelector('.line_total .bold');
    let totalPriceDesktop = document.querySelector('.totals-desktop.totals .totals__subtotal-value');
    let currency =  document.querySelector('.totals-mobile .shop-currency');
    if (shippingLine) {
      shippingLine.innerText = "FREE";
      shippingLine.style.color = "#F70093";
    }
    if (progressBar) {
      progressBar.querySelector('.cg-free-shipping-text').innerText = "🎉 Congratulations! You've unlocked FREE shipping!";
      progressBar.querySelector('.cg-progress-bar.progress-bar').style.width = "100%";
    }    
    if (totalPrice) {
      totalPrice.innerText =  currency.innerText + "" + totalPriceHeader.innerText.replace(/[^\d.,]/g, '');
    }
    if (totalPriceDesktop) {
      totalPriceDesktop.innerText =  totalPriceHeader.innerText;
    }
    }
    else {
    console.log("[Discount Apply] No valid shipping discount code found.");
    }
  }

  applyProductDiscount();
  applyShippingDiscount();
});
